// Lot 679 — cadre « photo seule » du fil (PhotoGallery) : hauteur CSS réellement affichée = largeur / ratio (le ratio
// est déjà borné 4:5 … 1.91:1 par la carte), plafonnée à 520 px ; ratio inconnu → 520 (pire cas). Sert à choisir la
// variante d'image sur le PLUS GRAND côté affiché : paysage → 864 px suffisent sur téléphone (au lieu de 1280),
// portrait → 1080 (au lieu de 1280) ; jamais de flou puisqu'on ne descend jamais sous la taille affichée.
export const SINGLE_PHOTO_MAX_H = 520;

export const singlePhotoHeight = (style, width) => {
  const ratio = Number(style?.["--ph-ratio"]);
  return Math.min(SINGLE_PHOTO_MAX_H, ratio > 0 ? width / ratio : SINGLE_PHOTO_MAX_H);
};
